module.exports = __webpack_public_path__ + "images/beyond-image-carrot-white.6a71309e.png";